// extracted by mini-css-extract-plugin
module.exports = {"LanguageSwitcher":"LanguageSwitcher_LanguageSwitcher__1CkJy","active":"LanguageSwitcher_active__1rp6c"};